// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2_KL3","title":"Images90_title__3AQFZ","images":"Images90_images__MF4rO"};